import { scientificMockData } from "./mock/scientificProgramMockData";

/**
 * Mengambil semua data scientific program
 * Simulasi delay 500ms agar LoadingCircle terlihat
 */
export const getDataByAll = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(scientificMockData);
    }, 500);
  });
};

/**
 * (Opsional) Mengambil data berdasarkan hall atau session jika diperlukan nanti
 */
export const getScientificByHall = (hallName) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const filtered = scientificMockData.filter(item => item.hall.includes(hallName));
      resolve(filtered);
    }, 300);
  });
};